import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/ags/layouts/default.vue").then(m => m.default || m))
}